<template>
  <div class="about-page">
    <div class="container py-4">
      <div v-if="loading" class="about-loading">
        <div class="skel skel-hero"></div>
        <div class="skel skel-line w-40"></div>
        <div class="skel skel-line w-90"></div>
      </div>

      <div v-else-if="!about || !about.content" class="about-state">
        <i class="pi pi-info-circle"></i>
        <p>لا يوجد محتوى بعد.</p>
      </div>

      <template v-else>
        <SectionHeader label="من نحن" :title="about.title || 'من نحن'" :subtitle="about.subtitle" />
        <img v-if="about.image_link" :src="about.image_link" :alt="about.title" class="about-hero" />
        <div class="about-content" v-html="about.content"></div>

        <div class="about-vm-grid" v-if="about.vision || about.mission">
          <div v-if="about.vision" class="about-vm-card">
            <h3><i class="pi pi-compass"></i> رؤيتنا</h3>
            <p>{{ about.vision }}</p>
          </div>
          <div v-if="about.mission" class="about-vm-card">
            <h3><i class="pi pi-flag"></i> رسالتنا</h3>
            <p>{{ about.mission }}</p>
          </div>
        </div>

        <div class="about-stats-grid" v-if="about.statistics && about.statistics.length">
          <div v-for="(stat, idx) in about.statistics" :key="idx" class="about-stat">
            <div class="about-stat__value">{{ stat.value }}</div>
            <div class="about-stat__label">{{ stat.label }}</div>
          </div>
        </div>

        <div class="about-gallery" v-if="about.gallery && about.gallery.length">
          <div class="about-gallery__grid">
            <img v-for="img in about.gallery" :key="img.path" :src="img.link" alt="" loading="lazy" />
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import SectionHeader from '@/components/common/SectionHeader.vue';
import { blogService } from '@/services/blogService.js';
import { applySeoMeta } from '@/composables/useSeoMeta';

export default {
  name: 'AboutPage',
  components: { SectionHeader },
  data() {
    return {
      about: null,
      loading: true,
    };
  },
  async mounted() {
    try {
      this.about = await blogService.aboutPage();
    } finally {
      this.loading = false;
    }
    this._seoCleanup = applySeoMeta({
      title: `${this.about?.meta_title || 'من نحن'} | أ/ مصطفى حسني - مدرس الكيمياء`,
      description: this.about?.meta_description || 'تعرّف على أ/ مصطفى حسني ومنصته التعليمية لتدريس الكيمياء.',
      canonical: 'https://moustafahosney.com/about',
      image: this.about?.og_image || undefined,
      type: 'article',
    });
  },
  beforeUnmount() {
    if (this._seoCleanup) this._seoCleanup();
  },
};
</script>

<style scoped>
.about-page { min-height: 60vh; padding-bottom: 5rem; max-width: 780px; margin: 0 auto; }
.about-hero { width: 100%; max-height: 380px; object-fit: cover; border-radius: 20px; margin-bottom: 2rem; }
.about-content { line-height: 1.9; color: #1F2937; font-size: 1.02rem; }
.about-content :deep(img) { max-width: 100%; border-radius: 12px; margin: 1rem 0; }
.about-state { text-align: center; padding: 3.5rem 1rem; color: #94a3b8; }
.about-state .pi { font-size: 2.6rem; margin-bottom: .8rem; display: block; }
.about-loading { padding: 1rem 0; }
.skel { background: #e9edf5; border-radius: 8px; position: relative; overflow: hidden; margin-bottom: .8rem; }
.skel::after {
  content: ''; position: absolute; inset: 0; transform: translateX(-100%);
  background: linear-gradient(90deg, transparent, rgba(255,255,255,.6), transparent);
  animation: skel-shimmer 1.3s infinite;
}
@keyframes skel-shimmer { 100% { transform: translateX(100%); } }
.skel-hero { aspect-ratio: 16/7; border-radius: 20px; }
.skel-line { height: 14px; }
.w-40 { width: 40%; } .w-90 { width: 90%; }

.about-vm-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(240px, 1fr)); gap: 1.25rem; margin-top: 2.5rem; }
.about-vm-card { background: #f8fafc; border: 1px solid #E5E7EB; border-radius: 16px; padding: 1.5rem; }
.about-vm-card h3 { display: flex; align-items: center; gap: 0.5rem; font-size: 1.05rem; font-weight: 800; color: #051629; margin-bottom: 0.6rem; }
.about-vm-card p { color: #4B5563; line-height: 1.8; margin: 0; }

.about-stats-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(120px, 1fr)); gap: 1rem; margin-top: 2.5rem; }
.about-stat { text-align: center; background: rgba(5, 22, 41, 0.05); border-radius: 16px; padding: 1.5rem 1rem; }
.about-stat__value { font-size: 1.8rem; font-weight: 800; color: #051629; }
.about-stat__label { font-size: 0.86rem; color: #6B7280; margin-top: 0.3rem; }

.about-gallery { margin-top: 2.5rem; }
.about-gallery__grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(160px, 1fr)); gap: 0.9rem; }
.about-gallery__grid img { width: 100%; aspect-ratio: 1; object-fit: cover; border-radius: 14px; }
</style>
